import { cva } from 'class-variance-authority';

const tabsTabBaseStyles = [
    'inline-block',
    'p-4',
    'border-b-2',
    'rounded-t-sm',
    'cursor-pointer',
    'user-select-none',
    'w-full',
    'text-center'
];

const tabsTabStylesSAG = cva([
    ...tabsTabBaseStyles,
    'border-transparent',

    'hover:bg-[#D1FFF2]',
    'hover:border-[#005159]',
    'dark:hover:bg-[#001F39]',
    'dark:hover:border-[#00FFB9]'
]);

const tabsTabStylesActiveSAG = cva([...tabsTabBaseStyles, 'border-[#005159]', 'dark:border-[#00FFB9]']);

const tabsTabStylesDisabledSAG = cva([
    ...tabsTabBaseStyles,
    'cursor-not-allowed',
    'pointer-events-none',
    'text-[#737389]',

    'dark:text-[#737389]'
]);

const tabsTabStylesSHS = cva([
    ...tabsTabBaseStyles,
    'border-transparent',

    'hover:text-[#1a1a1a]',
    'dark:hover:text-[#e6e6e6]'
]);

const tabsTabStylesActiveSHS = cva([
    ...tabsTabBaseStyles,
    'hover:text-[#1a1a1a]',
    'border-[#ec6602]',
    'dark:hover:text-[#e6e6e6]',
    'dark:border-[#ec6602]'
]);

const tabsTabStylesDisabledSHS = cva([
    ...tabsTabBaseStyles,
    'cursor-not-allowed',
    'pointer-events-none',
    'text-[#ededed]',

    'dark:text-[#7a7a7a]'
]);

export {
    tabsTabStylesSAG,
    tabsTabStylesActiveSAG,
    tabsTabStylesDisabledSAG,
    tabsTabStylesSHS,
    tabsTabStylesActiveSHS,
    tabsTabStylesDisabledSHS
};
